import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isNewbuildingFromDeveloper: TComputedPropMapper<boolean> = ({ offer }): boolean => {
  const { newbuilding, dealType, offerType } = offer;

  return dealType === 'sale' && offerType === 'flat' && Boolean(newbuilding && newbuilding.isFromDeveloper);
};
